import { Auth } from 'aws-amplify';
import 'jquery-serializejson';
import axios from 'axios';
import get from 'lodash/get';
import qs from 'qs';
import HtmlHelper from 'foundation/html-helper';
import { AmplifyClient } from 'project/amplify-client';
import FormComponent from './form.component';
import facebook from '../../social-provider/js/facebook';
import google from '../../social-provider/js/google';
import amazon from '../../social-provider/js/amazon';
import pageSpinner from '../../../general/js/page-spinner';
import userService from '../../../general/js/user/user-service';
import errorsSummaryTemplate from '../html/errors-summary.hbs';
import GTM from '../../../general/js/gtm';
import { redirectTo } from '../../../general/js/utils';

const api = axios.create({
    timeout: 60000,
    withCredentials: true,
});

const PROFILE_API_URL = window.appState.ssoConfig.userProfileApiUrl;
const CHECK_EMAIL_URL = PROFILE_API_URL + 'UserProfile/checkEmail';
const REGISTRATION_URL = PROFILE_API_URL + 'UserProfile';
const UPDATE_ACCOUNT_URL = PROFILE_API_URL + 'UserProfile';
const GET_USER_PROFILE_URL = PROFILE_API_URL + 'UserProfile';
const CREATE_TICKET_ACCOUNT_URL = PROFILE_API_URL + 'UserProfile/createTicketingAccount';
const CHANGE_PASSWORD_URL = PROFILE_API_URL + 'UserProfile/changePassword';
const CONFIRM_PASSWORD_URL = PROFILE_API_URL + 'UserProfile/confirmForgotPassword';
const FORGOT_PASSWORD_URL = PROFILE_API_URL + 'UserProfile/forgotPassword';

const HEADERS = {
    'Access-Control-Allow-Origin': window.location.origin,
    'Content-Type': 'application/json'
};

const SERVER_ERROR_MESSAGE = 'Something went wrong';
const USER_NOT_FOUND_ERROR_MESSAGE = 'Your login attempt was unsuccessfull. Please try again.';

const GENERATE_PASSWORD_URL = '/api/sitecore/account/generatepassword';
const ASYNC_ACTION_SAML = 'SamlRequest';

export default class FormSsoComponent extends FormComponent {
    constructor(...args) {
        super(...args);

        this.formData = {};
        this.formNode = this.refs.form ? this.refs.form : this.element;

        AmplifyClient.init();

        this.setFormFieldTracking();

        this.setUrl();
        this.setFormType();
        this.addListeners();
        // this.initProviders();
    }

    setUrl() {
        this.ACCOUNT_SIGNIN_URL = this.getAttribute(this.element, 'signin-url');
        this.COMPLETE_DETAILS_URL = this.getAttribute(this.element, 'complete-details-url');
        this.SIGN_OUT_URL = this.refs.signOut ? this.getAttribute(this.refs.signOut, 'signout') : '';
        this.DEFAULT_REDIRECT_URL = '/';
    }

    setFormType() {
        this.getAccessToken();

        if (this.getAttribute(this.element, 'type') === 'register') {
            this.formType = 'register';
            this.formNode = this.refs.form;
        } else if (this.getAttribute(this.element, 'type') === 'register-light') {
            this.formType = 'register-light';
            this.formNode = this.refs.form;
        } else if (this.getAttribute(this.element, 'type') === 'signin') {
            this.formType = 'signin';
            this.addListener(this.refs.forgotPasswordLink, 'click', this.onShowForgotPassword);
            this.formNode = this.refs.form;
        }
    }

    addListeners() {
        this.addListener(this.element, 'submit', this.onSubmit);

        if (this.refs.submitButton) {
            this.addListener(this.refs.submitButton, 'click', this.onSubmit);
        }

        if (this.refs.optInToOneClub) {
            this.addListener(this.refs.optInToOneClub, 'click', this.onOptInOneClub);
        }

        if (this.refs.signOut) {
            this.addListener(this.refs.signOut, 'click', this.onSignOut);
        }

        if (this.refs.updateButton) {
            this.addListener(this.refs.updateButton, 'click', this.onUpdateConsents);
        }

        if (this.refs.changePassword) {
            this.addListener(this.refs.changePassword, 'click', this.onChangePassword);
        }

        if (this.refs.updateAddressSubmit) {
            this.addListener(this.refs.updateAddressSubmit, 'click', this.onUpdateAddress);
        }

        if (this.refs.updateDetailsSubmit) {
            this.addListener(this.refs.updateDetailsSubmit, 'click', this.onUpdateDetails);
        }

        if (this.refs.completeDetailsSubmit) {
            this.addListener(this.refs.completeDetailsSubmit, 'click', this.onCompleteDetails);
        }

        if (this.refs.emailInput) {
            this.addListener(this.refs.emailInput, 'focusout', this.onEmailFocusOut);
        }
    }

    initProviders() {
        facebook.load(this.options.facebook.appId).then(() => {
            if (!this.refs.facebook) return;
            this.addListener(this.refs.facebook, 'click', this.onSocialSignin.bind(this, 'facebook'));
        });

        google.load(this.options.google.clientId).then(() => {
            if (!this.refs.google) return;
            this.onSocialSignin('google');
        });

        amazon.load(this.options.amazon.clientId).then(() => {
            if (!this.refs.amazon) return;
            this.addListener(this.refs.amazon, 'click', this.onSocialSignin.bind(this, 'amazon'));
        });
    }

    onSocialSignin = (provider) => {
        if (provider === 'facebook') {
            facebook.signIn().then((authObject) => {
                facebook.getUserObject().then((user) => {
                    //this.federatedSignIn(provider, authObject.accessToken, authObject.expiresIn, `${user.username}.${user.id}`);
                    this.federatedSignIn(provider, authObject.accessToken, authObject.expiresIn, user.username, user.id);
                });
            });
        } else if (provider === 'google') {
            google.signIn(this.refs.google).then((authObject) => {
                google.getUserObject().then((user) => {
                    //this.federatedSignIn(provider, authObject.accessToken, authObject.expiresIn, `${user.username}.${user.id}`);
                    this.federatedSignIn(provider, authObject.accessToken, authObject.expiresIn, user.username, user.id);
                });
            }, (error) => {
                console.log(error);
            });
        } else if (provider === 'amazon') {
            amazon.signIn().then((authObject) => {
                amazon.getUserObject().then((user) => {
                    //this.federatedSignIn(provider, authObject.accessToken, authObject.expiresIn, `${user.username}.${user.id}`);
                    this.federatedSignIn(provider, authObject.accessToken, authObject.expiresIn, user.username, user.id);
                });
            }, (error) => {
                console.log(error);
            });
        }
    };

    federatedSignIn = (socialProvider, accessToken, expiresIn, username) => {
        const date = new Date();
        const expiresAt = expiresIn * 1000 + date.getTime();

        pageSpinner.show();

        Auth.federatedSignIn(socialProvider, { token: accessToken, expiresAt }, username)
            .then((credentials) => {
                console.log(credentials);
                this.requestGeneratedPassword().then((generatedPassword) => {
                    const password = generatedPassword.data.toString();
                    this.signIn(username, password, socialProvider);
                });
            })
            .catch((err) => {
                console.log(err);
                if (err === 'not authenticated') {
                    this.requestGeneratedPassword().then((generatedPassword) => {
                        const password = generatedPassword.data.toString();
                        this.showCompleteRegister(socialProvider, username, password);
                    });
                }
            });
    };

    hideErrorsSummary() {
        if (this.errorsSummary) {
            this.errorsSummary.forEach((errorsSummary) => {
                errorsSummary.classList.remove('is-shown');
            });
        }
    }

    onSubmit = (event) => {
        event.preventDefault();

        if (this.refs.form && this.refs.form.classList.contains('is-hidden')) return false;

        this.hideErrorsSummary();
        this.revalidateForm().then(() => {
            pageSpinner.show();

            if (this.formType === 'register') {
                const title = this.formData.Title ? this.formData.Title : '';
                const firstName = this.formData.FirstName;
                const lastName = this.formData.Surname;
                const email = this.formData.EmailAddress.toLowerCase();
                const address = {
                    addressLine1: this.formData.AddressLine1 ? this.formData.AddressLine1 : '',
                    addressLine2: this.formData.AddressLine2 ? this.formData.AddressLine2 : '',
                    postcode: this.formData.Postcode ? this.formData.Postcode : '',
                    city: this.formData.City ? this.formData.City : '',
                    country: this.formData.Country,
                    county: this.formData.County ? this.formData.County : '',
                };
                const dateOfBirth = this.getDateOfBirth();
                const password = this.formData.Password;
                const interests = this.getVenuesObject();
                const checkboxesValuesObject = this.collectCheckboxesData();
                const optIns = {
                    optedTheOpenOffersByEmail: !checkboxesValuesObject.OptedTheOpenOffersByEmail,
                    optedPartnerOffersByEmail: checkboxesValuesObject.OptedPartnersOffersByEmail,
                    agreedToPrivacyPolicy: checkboxesValuesObject.AgreedToPrivacyPolicy
                };
                const isOneClubMember = this.refs.isOneClubMember ? this.refs.isOneClubMember.value : false;
                const createTicketingAccount = (this.getAttribute(this.element, 'checkout') === 'true');
                const antiForgeryToken = this.element.querySelector('input[name="__RequestVerificationToken"]') ? this.element.querySelector('input[name="__RequestVerificationToken"]').value : '';
                const fieldsData = {
                    user: {
                        title,
                        email,
                        firstName,
                        lastName,
                        address,
                        dateOfBirth,
                        optIns,
                        interests,
                        ticketingAccountId: '',
                        isOneClubMember
                    },
                    password,
                    createTicketingAccount
                };

                this.register(fieldsData, antiForgeryToken);
            } else if (this.formType === 'register-light') {
                const title = '';
                const firstName = this.formData.FirstName;
                const lastName = this.formData.Surname;
                const dateOfBirth = this.getDateOfBirth();
                const email = this.formData.EmailAddress.toLowerCase();
                const address = {
                    country: this.formData.Country,
                    county: this.formData.County ? this.formData.County : ''
                };
                const password = this.formData.Password;
                const checkboxesValuesObject = this.collectCheckboxesData();
                const optIns = {
                    optedTheOpenOffersByEmail: !checkboxesValuesObject.OptedTheOpenOffersByEmail,
                    optedPartnerOffersByEmail: checkboxesValuesObject.OptedPartnersOffersByEmail,
                    agreedToPrivacyPolicy: checkboxesValuesObject.AgreedToPrivacyPolicy
                };
                const isOneClubMember = true;
                const createTicketingAccount = false;
                const antiForgeryToken = this.element.querySelector('input[name="__RequestVerificationToken"]') ? this.element.querySelector('input[name="__RequestVerificationToken"]').value : '';
                const fieldsData = {
                    user: {
                        title,
                        email,
                        firstName,
                        lastName,
                        dateOfBirth,
                        address,
                        optIns,
                        ticketingAccountId: '',
                        isOneClubMember
                    },
                    password,
                    createTicketingAccount
                };

                this.register(fieldsData, antiForgeryToken);
            } else if (this.formType === 'signin') {
                const username = this.formData.EmailAddress.toLowerCase();
                const password = this.formData.Password;
                const antiForgeryToken = this.element.querySelector('input[name="__RequestVerificationToken"]') ? this.element.querySelector('input[name="__RequestVerificationToken"]').value : '';
                this.signIn(username, password, antiForgeryToken);
            }

            return false;
        });

        return false;
    };

    register(fieldsData, antiForgeryToken) {
        api.post(REGISTRATION_URL, fieldsData, {
            headers: HEADERS
        })
            .then((result) => {
                pageSpinner.hide();
                this.sendFormTracking();
                const errors = get(result.data, 'errors', null);
                if (errors) {
                    this.showServerError(errors.general);
                } else if (this.getAttribute(this.element, 'checkout') === 'true') {
                    this.signIn(fieldsData.user.email, fieldsData.password, antiForgeryToken);
                } else {
                    userService.signOut()
                        .then(() => {
                            this.onUserNotConfirmed();
                        })
                        .catch((err) => {
                            this.showServerError(err);
                        });
                }
            }, (err) => {
                if (err.response.status === 409) {
                    pageSpinner.hide();
                    this.showServerError(err.response.data);
                } else {
                    pageSpinner.hide();
                    this.showServerError(SERVER_ERROR_MESSAGE);
                }
            });
    }

    requestGeneratedPassword() {
        return api.get(GENERATE_PASSWORD_URL)
            .then((response) => {
                return Promise.resolve(response);
            }, (error) => {
                return Promise.reject(error);
            });
    }

    signIn(username, password, antiForgeryToken, socialProvider = '') {
        const userName = username.trim();

        this.checkSignIn().then(() => {
            Auth.signIn(userName, password).then((user) => {
                this.user = user;

                if (user.challengeName === 'SMS_MFA' ||
                    user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                    // You need to get the code from the UI inputs
                    // and then trigger the following function with a button click
                    //const code = getCodeFromUserInput();
                    // If MFA is enabled, sign-in should be confirmed with the confirmation code
                    // (async () => {
                    //     const loggedUser = await Auth.confirmSignIn(
                    //         user,   // Return object from Auth.signIn()
                    //         code,   // Confirmation code
                    //         mfaType // MFA Type e.g. SMS, TOTP.
                    //     );
                    // })();
                } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    this.onShowCompletePassword(user);
                } else if (user.challengeName === 'MFA_SETUP') {
                    // This happens when the MFA method is TOTP
                    // The user needs to setup the TOTP before using it
                    // More info please check the Enabling MFA part
                    Auth.setupTOTP(user);
                } else {
                    // The user directly signs in
                    const emailAddress = username;
                    const returnUrl = this.refs.returnUrl ? this.refs.returnUrl.value : '/';
                    const loginFailedReturnUrl = this.refs.loginFailedReturnUrl ? this.refs.loginFailedReturnUrl.value : '/';

                    this.getAccessToken().then((token) => {
                        this.getCurrentUser(token).then((currentUser) => {
                            const secuTixSignInRequest = {
                                emailAddress,
                                password,
                                returnUrl,
                                loginFailedReturnUrl,
                                __RequestVerificationToken: antiForgeryToken
                            };

                            if (this.getAttribute(this.element, 'checkout') === 'true') {
                                if (currentUser.ticketingAccountId) {
                                    this.secutixSignIn(secuTixSignInRequest);
                                } else if (!this.checkRequiredSecutixFields(currentUser)) {
                                    redirectTo(this.COMPLETE_DETAILS_URL);
                                } else {
                                    const headers = this.setAuthorizationHeader(token);

                                    api.post(CREATE_TICKET_ACCOUNT_URL, { emailAddress, password }, {
                                        headers
                                    })
                                        .then(() => {
                                            this.secutixSignIn(secuTixSignInRequest);
                                        }, () => {
                                            this.showServerError(SERVER_ERROR_MESSAGE);
                                        });
                                }
                            } else {
                                this.sendFormTracking();
                                this.redirect();
                            }
                        });
                    });
                }
            }, (err) => {
                if (err.code === 'UserNotConfirmedException' && socialProvider) {
                    // The error happens if the user didn't finish the confirmation step when signing up
                    // In this case you need to resend the code and confirm the user
                    // About how to resend the code and confirm the user, please check the signUp part
                    this.showCompleteRegister(socialProvider, username, password);
                } else if (err.code === 'UserNotConfirmedException') {
                    this.onUserNotConfirmed(username, password);
                } else if (err.code === 'PasswordResetRequiredException') {
                    // The error happens when the password is reset in the Cognito console
                    // In this case you need to call forgotPassword to reset the password
                    // Please check the Forgot Password part.
                    this.onShowForgotPassword();
                } else if (err.code === 'UserNotFoundException' && socialProvider) {
                    this.showCompleteRegister(socialProvider, username, password);
                } else if (err.code === 'UserNotFoundException') {
                    this.showServerError(USER_NOT_FOUND_ERROR_MESSAGE);
                } else {
                    this.showServerError(err);
                }
            });
        });
    }

    secutixSignIn(signInRequest) {
        const formData = qs.stringify(signInRequest);

        fetch(this.ACCOUNT_SIGNIN_URL, {
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'POST',
            body: formData
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }

            throw new Error('invalid signin response');
        }).then((data) => {
            this.sendFormTracking();
            if (data.action === ASYNC_ACTION_SAML) {
                const formString = data.content.match(/<form(.+)((\s)+(.+))+<\/form>/i);

                if (!formString || !formString.length) {
                    throw new Error('Server doesn\'t returned form');
                }

                const syncForm = HtmlHelper.createElement(formString[0]);

                document.body.appendChild(syncForm);
                syncForm.submit();
            }
        });
    }

    checkRequiredSecutixFields(user) {
        return (
            user.title &&
            user.address.addressLine1 &&
            user.address.postcode &&
            user.address.city &&
            user.address.country &&
            user.interests.venues &&
            user.optIns.agreedToPrivacyPolicy
        );
    }

    updateUserObject(userAttributesObject, token) {
        pageSpinner.show();

        const headers = this.setAuthorizationHeader(token);

        api.put(UPDATE_ACCOUNT_URL, userAttributesObject, {
            headers
        })
            .then(() => {
                pageSpinner.hide();
                this.redirect();
            }, (err) => {
                console.log(JSON.stringify(err.response.data.errors));
                pageSpinner.hide();
                if (err.response.status === 400) {
                    this.showServerError(err.response.data.errors);
                } else {
                    this.showServerError(SERVER_ERROR_MESSAGE);
                }
            });
    }

    onUserNotConfirmed(username, password) {
        if (this.options.emailConfirmationWorkflow === 'code') {
            this.showRegistrationCodeField(username, password);
        } else {
            this.showSuccessMessage();
        }
    }

    showRegistrationCodeField(username, password) {
        this.refs.form.classList.add('is-hidden');
        this.refs.codeWrap.classList.add('is-visible');
        this.formNode = this.refs.codeWrap;
        this.setFormFieldTracking();

        this.addListener(this.refs.registrationCodeSubmit, 'click', (event) => {
            event.preventDefault();

            const code = this.refs.code.value;
            pageSpinner.show();
            // After retrieving the confirmation code from the user
            Auth.confirmSignUp(username, code)
                .then(() => {
                    this.signIn(username, password);
                })
                .catch((err) => {
                    pageSpinner.hide();
                    this.showServerError(err);
                });

            return false;
        });
    }

    showSuccessMessage() {
        pageSpinner.hide();
        this.refs.form.classList.add('is-hidden');
        this.refs.successMessage.classList.add('is-visible');
        this.refs.complete.classList.remove('is-visible');
    }

    showCompleteRegister(socialProvider, username, password) {
        pageSpinner.hide();
        this.refs.form.classList.add('is-hidden');
        this.refs.complete.classList.add('is-visible');
        this.formNode = this.refs.complete;
        this.setFormFieldTracking();

        this.addListener(this.refs.completeButton, 'click', (event) => {
            event.preventDefault();

            this.revalidateForm().then(() => {
                const firstName = this.formData.FirstName;
                const lastName = this.formData.Surname;
                const email = this.formData.EmailAddress;
                const checkboxesValuesObject = this.collectCheckboxesData();
                const optIns = {
                    optedTheOpenOffersByEmail: !checkboxesValuesObject.OptedTheOpenOffersByEmail,
                    optedPartnerOffersByEmail: checkboxesValuesObject.OptedPartnersOffersByEmail,
                    agreedToPrivacyPolicy: checkboxesValuesObject.AgreedToPrivacyPolicy
                };
                const interests = this.getVenuesObject();
                const isOneClubMember = false;

                this.register({
                    user: {
                        title: '',
                        email,
                        firstName,
                        lastName,
                        address: '',
                        dateOfBirth: '',
                        optIns,
                        interests,
                        ticketingAccountId: '',
                        isOneClubMember
                    },
                    password,
                    createTicketingAccount: false
                });

                return false;
            });
        });
    }

    onShowForgotPassword = (event) => {
        if (event) {
            event.preventDefault();
        }

        this.refs.passwordResetSuccess.classList.remove('is-visible');
        this.refs.forgotPasswordInput.value = '';

        if (this.errorsSummary) {
            this.errorsSummary.forEach((errorsSummary) => {
                errorsSummary.innerHTML = '';
                errorsSummary.classList.remove('is-shown');
            });
        }

        this.refs.form.classList.add('is-hidden');

        this.refs.forgotPassword.classList.add('is-visible');

        this.formNode = this.refs.forgotPassword;

        this.setFormFieldTracking();

        this.addListener(this.refs.forgotPasswordSubmit, 'click', (e) => {
            e.preventDefault();

            this.revalidateForm().then(() => {
                const email = {
                    emailAddress: this.formData.EmailAddress
                };
                pageSpinner.show();
                api.post(FORGOT_PASSWORD_URL, email, {
                    headers: HEADERS
                })
                    .then(() => {
                        pageSpinner.hide();
                        this.sendFormTracking();
                        this.showPasswordCodeField(email);
                        this.hideErrorsSummary();
                    }, (error) => {
                        pageSpinner.hide();

                        if (error.response && error.response.status === 404) {
                            this.sendFormTracking();
                            this.showPasswordCodeField(email);
                        } else if (error.response && error.response.status === 429) {
                            this.showServerError(error, true);
                        } else {
                            this.showServerError(error);
                        }
                    });
            });
        });
    };

    onShowCompletePassword = (user) => {
        pageSpinner.hide();
        this.refs.form.classList.add('is-hidden');
        this.refs.completePassword.classList.add('is-visible');
        this.formNode = this.refs.completePassword;
        this.setFormFieldTracking();

        this.addListener(this.refs.completePasswordSubmit, 'click', (e) => {
            e.preventDefault();

            this.revalidateForm().then(() => {
                const newPassword = this.formData.Password;

                pageSpinner.show();
                Auth.completeNewPassword(
                    user,
                    newPassword,
                    {
                        email: user.email
                    }
                ).then(() => {
                    pageSpinner.hide();
                    this.sendFormTracking();
                    this.redirect();
                }).catch(() => {
                    pageSpinner.hide();
                    this.showServerError(SERVER_ERROR_MESSAGE);
                });
            });
        });
    };

    showPasswordCodeField(email) {
        this.refs.form.classList.add('is-hidden');
        this.refs.forgotPassword.classList.remove('is-visible');
        this.refs.codeWrap.classList.add('is-visible');
        this.formNode = this.refs.codeWrap;
        this.setFormFieldTracking();

        this.refs.code.value = '';
        this.refs.newPasswordInput.value = '';
        this.refs.newPasswordInputConfirm.value = '';

        this.addListener(this.refs.codeSubmit, 'click', (event) => {
            event.preventDefault();

            this.revalidateForm().then(() => {
                pageSpinner.show();

                api.post(CONFIRM_PASSWORD_URL, {
                    emailAddress: email.emailAddress,
                    confirmationCode: this.formData.Code,
                    newPassword: this.formData.Password
                }, {
                    headers: HEADERS
                })
                    .then(() => {
                        pageSpinner.hide();
                        this.sendFormTracking();
                        this.refs.passwordResetSuccess.classList.add('is-visible');
                        this.refs.form.classList.remove('is-hidden');
                        this.refs.codeWrap.classList.remove('is-visible');
                        this.hideErrorsSummary();
                        this.formNode = this.refs.form;
                        this.setFormFieldTracking();
                    }, (err) => {
                        pageSpinner.hide();
                        this.showServerError(err.response.data);
                    });
            });
        });
    }

    onChangePassword = (event) => {
        event.preventDefault();

        this.revalidateForm().then(() => {
            const oldPassword = this.formData.OldPassword;
            const newPassword = this.formData.Password;

            this.getAccessToken()
                .then((token) => {
                    const headers = this.setAuthorizationHeader(token);

                    api.post(CHANGE_PASSWORD_URL, {
                        oldPassword,
                        newPassword
                    }, {
                        headers
                    })
                        .then(() => {
                            if (this.refs.changePasswordSuccess) {
                                this.refs.form.classList.add('is-hidden');
                                this.refs.changePasswordSuccess.classList.add('is-visible');
                                this.formNode = this.refs.changePasswordSuccess;
                                this.hideErrorsSummary();
                                this.setFormFieldTracking();
                            } else {
                                this.redirect();
                            }
                        }, (error) => {
                            if (error.response && error.response.data) {
                                this.showServerError(error.response.data);
                            } else {
                                this.showServerError(error);
                            }
                        });
                })
                .catch(() => {
                    this.showServerError(SERVER_ERROR_MESSAGE);
                });
        });
    };

    onSignOut = (event) => {
        event.preventDefault();

        userService.setHostedUIReturnUrl(this.SIGN_OUT_URL);

        userService.signOut()
            .then(() => {
            })
            .catch((err) => {
                this.showServerError(err);
            });
    };

    onOptInOneClub = (event) => {
        event.preventDefault();

        this.revalidateForm().then(() => {
            const checkboxesValuesObject = this.collectCheckboxesData();
            const optInValue = checkboxesValuesObject.OptInToTheOneClub;

            this.getAccessToken().then((token) => {
                const userAttributesObject = {
                    user: {
                        isOneClubMember: optInValue
                    }
                };
                this.updateUserObject(userAttributesObject, token);
            });
        });
    };

    onUpdateConsents = (event) => {
        event.preventDefault();

        this.revalidateForm().then(() => {
            const checkboxesValuesObject = this.collectCheckboxesData();
            const interests = this.getVenuesObject();

            const optIns = {
                optedTheOpenOffersByEmail: !checkboxesValuesObject.OptedTheOpenOffersByEmail,
                optedPartnerOffersByEmail: checkboxesValuesObject.OptedPartnersOffersByEmail
            };

            this.getAccessToken().then((token) => {
                const userAttributesObject = {
                    user: {
                        interests,
                        optIns
                    }
                };

                this.updateUserObject(userAttributesObject, token);
            });
        });
    };

    onUpdateAddress = (event) => {
        event.preventDefault();

        this.revalidateForm().then(() => {
            const address = {
                addressLine1: this.formData.AddressLine1,
                addressLine2: this.formData.AddressLine2,
                postcode: this.formData.Postcode,
                city: this.formData.City,
                country: this.formData.Country,
                county: this.formData.County ? this.formData.County : ''
            };

            this.getAccessToken().then((token) => {
                const userAttributesObject = {
                    user: {
                        address
                    }
                };

                this.updateUserObject(userAttributesObject, token);
            });
        });
    };

    onUpdateDetails = (event) => {
        event.preventDefault();
        const dateOfBirth = this.getDateOfBirth();

        this.revalidateForm().then(() => {
            this.getAccessToken().then((token) => {
                const userAttributesObject = {
                    user: {
                        title: this.formData.Title,
                        firstName: this.formData.FirstName,
                        lastName: this.formData.LastName,
                        email: this.formData.Email,
                        dateOfBirth
                    }
                };

                this.updateUserObject(userAttributesObject, token);
            });
        });
    };

    onCompleteDetails = (event) => {
        event.preventDefault();

        this.revalidateForm().then(() => {
            this.setFormFieldTracking();
            let dateOfBirth;

            if (this.element.querySelector('[data-dc-form-date-ref="day"]')) {
                dateOfBirth = this.getDateOfBirth();
            } else {
                dateOfBirth = this.element.querySelector('[name=DateOfBirth]').value;
            }

            const firstName = this.formData.FirstName;
            const lastName = this.formData.LastName;

            const interests = this.getVenuesObject();

            const address = {
                addressLine1: this.formData.AddressLine1,
                addressLine2: this.formData.AddressLine2,
                postcode: this.formData.Postcode,
                city: this.formData.City,
                country: this.formData.Country,
                county: this.formData.County ? this.formData.County : ''
            };

            this.getAccessToken().then((token) => {
                const userAttributesObject = {
                    user: {
                        title: this.formData.Title,
                        firstName,
                        lastName,
                        address,
                        dateOfBirth,
                        interests
                    },
                    createTicketingAccount: this.refs.createTicketingAccount ? this.refs.createTicketingAccount.value : false
                };

                this.sendFormTracking();
                this.updateUserObject(userAttributesObject, token);
            });
        });
    };

    onEmailFocusOut = () => {
        this.getParsleyForm().destroy();
        this._parsleyForm = null;
        this.getParsleyForm().fields.forEach((field) => {
            const name = field.$element[0].name;
            if (name) {
                const fieldName = name.substring(name.indexOf('.') + 1);
                this.formData[fieldName] = field.$element[0].value;
            }
        });

        const emailRequest = {
            emailAddress: this.formData.EmailAddress ? this.formData.EmailAddress : this.formData.Email
        };
        const emailJson = JSON.stringify(emailRequest);

        api.post(CHECK_EMAIL_URL, emailJson, {
            headers: HEADERS
        })
            .then(() => {
                const errorList = this.refs.emailInput.querySelector('ul');
                if (errorList) {
                    errorList.remove();
                }
            })
            .catch((error) => {
                if (error.response.status === 409) {
                    this.showFieldError(this.refs.emailInput, error.response.data);
                } else {
                    this.showServerError(SERVER_ERROR_MESSAGE);
                }
            });
    };

    revalidateForm() {
        return new Promise((resolve) => {
            this.getParsleyForm().destroy();
            this._parsleyForm = null;
            this.getParsleyForm().fields.forEach((field) => {
                const name = field.$element[0].name;
                if (name) {
                    const fieldName = name.substring(name.indexOf('.') + 1);
                    this.formData[fieldName] = field.$element[0].value;
                }
            });

            this.getParsleyForm().on('field:error', this.onFieldError);
            if (this.getParsleyForm().validate() === true) {
                resolve();
            }
        });
    }

    collectCheckboxesData() {
        const checkboxesInputs = [...this.formNode.querySelectorAll('input[type="checkbox"]')];

        function isArrayOrObject(name) {
            return /(.+)\[(.*)\]/.test(name);
        }

        return checkboxesInputs.reduce((result, checkbox) => {
            if (!isArrayOrObject(checkbox.name)) {
                result[checkbox.name] = checkbox.checked;
            }
            return result;
        }, {});
    }

    showErrorsSummary(groupped) {
        if (this.errorsSummary) {
            this.errorsSummary.forEach((errorsSummary) => {
                if (Object.keys(groupped).length) {
                    const errors = Object.keys(groupped).reduce((groupErrors, key) =>
                        [...groupErrors, ...groupped[key]], []);
                    errorsSummary.innerHTML = errorsSummaryTemplate({ errors });
                    errorsSummary.classList.add('is-shown');
                } else {
                    this.hideErrorsSummary();
                }
            });
        }
    }

    showServerError(err, data = false) {
        pageSpinner.hide();

        if (this.errorsSummary) {
            this.errorsSummary.forEach((errorsSummary) => {
                if (data) {
                    errorsSummary.innerHTML = err.response.data ? err.response.data : err;
                } else {
                    errorsSummary.innerHTML = err.message ? err.message : err;
                }

                errorsSummary.classList.add('is-shown');
            });
        }
    }

    showFieldError(inputElement, errors) {
        const errorListOld = inputElement.querySelector('ul');
        if (errorListOld) {
            errorListOld.remove();
        }
        const errorList = document.createElement('ul');
        errorList.classList.add('form-field__error-list');
        errorList.classList.add('filled');
        inputElement.appendChild(errorList);
        if (typeof errors === 'string') {
            this.createErrorItem(errors, errorList);
        } else if (typeof errors === 'object') {
            Object.values(errors).forEach((error) => {
                this.createErrorItem(error, errorList);
            });
        }
    }

    createErrorItem(error, errorList) {
        const errorItem = document.createElement('li');
        errorItem.classList.add('form-field__error-item');
        errorItem.innerHTML = error;
        errorList.appendChild(errorItem);
    }

    redirect() {
        const returnUrl = this.refs.returnUrl ? this.refs.returnUrl.value : this.getAttribute(this.element, 'return-url');

        redirectTo(returnUrl || this.DEFAULT_REDIRECT_URL);
    }

    sendFormTracking() {
        if (this.getAttribute(this.formNode, 'track')) {
            GTM.push(this.getTrackCategory(), this.getTrackAction(), this.getTrackLabel());
        }
    }

    setFormFieldTracking() {
        if (this.refs.trackFields && this.getAttribute(this.formNode, 'track')) {
            this.refs.trackFields.forEach((field) => {
                if (this.formNode.contains(field)) {
                    field.addEventListener('focusin', this.sendFormFieldTracking);
                }
            });
        }
    }

    sendFormFieldTracking(e) {
        const target = e.target;
        if (this.refs.trackFields && this.refs.trackFields.indexOf(target) !== -1) {
            const label = this.getAttribute(target, 'track-label');
            if (label) {
                GTM.push(this.getTrackCategory(), 'Field Entry', label);
            }
        }
    }

    setAuthorizationHeader(token) {
        return Object.assign(HEADERS, { Authorization: 'Bearer ' + token });
    }

    getTrackCategory() {
        this._trackCategory = this.getAttribute(this.formNode, 'track-category');
        return this._trackCategory;
    }

    getTrackAction() {
        this._trackAction = this.getAttribute(this.formNode, 'track-action');
        return this._trackAction;
    }

    getTrackLabel() {
        this._trackLabel = this.getAttribute(this.formNode, 'track-label');
        return this._trackLabel;
    }

    getAccessToken() {
        return userService.getAccessToken();
    }

    getCurrentUser(token) {
        const headers = this.setAuthorizationHeader(token);

        return api.get(GET_USER_PROFILE_URL, {
            headers
        })
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch(() => {
                this.showServerError(SERVER_ERROR_MESSAGE);
            });
    }

    checkSignIn() {
        return Auth.currentSession()
            .then(() => {
                userService.signOut().catch((err) => {
                    this.showServerError(err);
                });
            })
            .catch(() => {
                return Promise.resolve();
            });
    }

    getDateOfBirth() {
        const day = this.element.querySelector('[data-dc-form-date-ref="day"]').value;
        const month = this.element.querySelector('[data-dc-form-date-ref="month"]').value;
        const year = this.element.querySelector('[data-dc-form-date-ref="year"]').value;
        return `${year}-${month}-${day}`;
    }

    getVenuesObject() {
        const interests = {
            venues: []
        };
        this.refs.venues.forEach((venue) => {
            if (venue.checked) {
                interests.venues.push(venue.value);
            }
        });
        return interests;
    }
}
